import React, { useEffect, useRef, useState } from 'react'
import * as Icons from 'react-feather'
import DataTable from 'react-data-table-component'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { Modal } from 'react-bootstrap'
import SKAlerts, { CreateAlert } from '../../shared/common-alerts/SKAlerts'
import { ReactComponent as SortArrow } from '../../shared/img/chevron-up-down.svg'
import FinanceRegisterModel from './models/FinanceRegisterModel'
import FinanceRegisterModal from './FinanceRegisterModal'
import StatusGridDropdown from '../../shared/common-dropdown/StatusGridDropdown'
import { getStorageValues } from '../../shared/CommonFunctions'
import { getApiBaseUrl } from '../../utils/apiConfig'
import { logAuditEvent } from '../../utils/auditLogger'
import FinanceRegisterFollowup from './FinanceRegisterFollowup'

function FinanceRegisterGrid(props) {
  const [actionType, setActionType] = useState()
  const [modalIsOpen, setIsOpen] = React.useState(false)
  const [financeRegisterModel, setFinanceRegisterModel] = useState(new FinanceRegisterModel())
  const [filterText, setFilterText] = React.useState('')
  const [alert, setAlert] = useState(null)
  const [editableCell, setEditableCell] = useState({ rowId: null, column: null })
  const [financeRows, setFinanceRows] = useState([])
  const [expandedRowId, setExpandedRowId] = useState(null)
  const [statusModalOpen, setStatusModalOpen] = useState(false)
  const [statusModalData, setStatusModalData] = useState({ row: null, option: null })
  const [loanAccountNumber, setLoanAccountNumber] = useState('')
  const [nextEmiDate, setNextEmiDate] = useState('')
  const [statusSaving, setStatusSaving] = useState(false)
  const followupRef = useRef(null)
  const moduleName = props.moduleName || 'Finance Register'

  useEffect(() => {
    setFinanceRows(props.FinanceRegisterData || [])
  }, [props.FinanceRegisterData])

  function closeModal() {
    setIsOpen(false)
    props.fetchFinanceRegisters()
  }

  const rows = financeRows
    ? financeRows.filter((item) =>
      (item.SalesNumber && item.SalesNumber.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.CustomerName && item.CustomerName.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.LoanApplicationNo && item.LoanApplicationNo.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.Status && item.Status.toLowerCase().includes(filterText.toLowerCase()))
    )
    : []

  const openActionType = async (row, name) => {
    const isCompleted = (row?.Status || '').toLowerCase() === 'completed' || (row?.Status || '').toLowerCase() === 'complete'
    if (isCompleted && (name === 'Edit' || name === 'Delete')) {
      CreateAlert('Completed finance register entries cannot be edited or deleted.', 'Warning', setAlert)
      return
    }
    logAuditEvent(moduleName, 'View/Edit/Delete/Email Button Click', JSON.stringify({
      Id: row?.FinanceRegisterId,
      Name: row?.CustomerName,
      Action: name
    }))

    if (name === 'Delete' || !row?.FinanceRegisterId) {
      setFinanceRegisterModel(row)
      setIsOpen(true)
      setActionType(name)
      return
    }

    try {
      const response = await axios.get(getApiBaseUrl() + '/financeregister/getbyid', {
        params: { FinanceRegisterId: row.FinanceRegisterId }
      })
      const record = response?.data?.data || row
      setFinanceRegisterModel(record)
      setIsOpen(true)
      setActionType(name)
    } catch (error) {
      console.log(error)
      CreateAlert('Unable to load finance register details', 'Error', setAlert)
    }
  }

  async function onSubmit(e, data) {
    const financeRegisterData = data
    if (e.target.name === 'Edit') {
      let financeRegisterDetails = {
        FinanceRegisterId: financeRegisterData.FinanceRegisterId,
        SalesId: financeRegisterData.SalesId,
        CustomerName: financeRegisterData.CustomerName,
        MobileNo: financeRegisterData.MobileNo,
        EmailId: financeRegisterData.EmailId,
        VehicleId: financeRegisterData.VehicleId,
        VehicleCost: financeRegisterData.VehicleCost,
        FinancePartnerId: financeRegisterData.FinancePartnerId,
        DownPayment: financeRegisterData.DownPayment,
        EMITenure: financeRegisterData.EMITenure,
        ProcessingFees: financeRegisterData.ProcessingFees,
        InterestRate: financeRegisterData.InterestRate,
        EMIAmount: financeRegisterData.EMIAmount,
        LoanApplicationNo: financeRegisterData.LoanApplicationNo,
        StatusId: financeRegisterData.StatusId,
        UserId: getStorageValues('userId')
      }
      if (validation(financeRegisterDetails)) {
        try {
          const response = await axios.post(
            getApiBaseUrl() + '/financeregister/save',
            financeRegisterDetails
          )
          if (response.status === 200) {
            if (response.data.data?.success === 1 || response.data.data?.success === undefined) {
              CreateAlert(response.data.data?.message || 'Finance register updated successfully!!', 'Success', setAlert)
              props.fetchFinanceRegisters()
              closeModal()
            } else {
              CreateAlert(response.data.data?.message || 'Unable to save record', 'Warning', setAlert)
            }
          }
        } catch (error) {
          console.log(error)
        }
      }
    } else if (e.target.name === 'Delete') {
      let financeRegisterDetails = {
        FinanceRegisterId: financeRegisterModel.FinanceRegisterId,
        UserId: getStorageValues('userId')
      }
      try {
        const response = await axios.post(
          getApiBaseUrl() + '/financeregister/delete',
          financeRegisterDetails
        )
        if (response.status === 200) {
          CreateAlert('Finance register deleted successfully!!', 'Success', setAlert)
          props.fetchFinanceRegisters()
          closeModal()
        }
      } catch (error) {
        console.log(error)
      }
    }
  }

  async function updateStatus(option, row) {
    if (!option || !row) return

    const statusLabel = (option.label || '').toLowerCase()
    const isComplete = statusLabel === 'complete' || statusLabel === 'completed'
    if (isComplete) {
      setStatusModalData({ row, option })
      setLoanAccountNumber(row?.LoanAccountNumber || '')
      setNextEmiDate(row?.NextEmiDate ? row?.NextEmiDate.split('T')[0] : '')
      setStatusModalOpen(true)
      return
    }

    const financeRegisterDetails = {
      FinanceRegisterId: row.FinanceRegisterId,
      SalesId: row.SalesId,
      CustomerName: row.CustomerName,
      MobileNo: row.MobileNo,
      EmailId: row.EmailId,
      VehicleId: row.VehicleId,
      VehicleCost: row.VehicleCost,
      FinancePartnerId: row.FinancePartnerId,
      DownPayment: row.DownPayment,
      EMITenure: row.EMITenure,
      ProcessingFees: row.ProcessingFees,
      InterestRate: row.InterestRate,
      EMIAmount: row.EMIAmount,
      LoanApplicationNo: row.LoanApplicationNo,
      StatusId: option.value,
      UserId: getStorageValues('userId')
    }

    try {
      const response = await axios.post(
        getApiBaseUrl() + '/financeregister/save',
        financeRegisterDetails
      )
      if (response.status === 200) {
        CreateAlert('Status updated successfully!!', 'Success', setAlert)
        logAuditEvent(moduleName, 'Status Update', JSON.stringify({
          Id: row.FinanceRegisterId,
          StatusId: option.value,
          Status: option.label
        }))
        props.fetchFinanceRegisters()
      }
    } catch (error) {
      console.log(error)
      CreateAlert('Unable to update status', 'Error', setAlert)
    }
  }

  const closeStatusModal = () => {
    setStatusModalOpen(false)
    setStatusModalData({ row: null, option: null })
    setLoanAccountNumber('')
    setNextEmiDate('')
  }

  const submitCompleteStatus = async () => {
    const { row, option } = statusModalData
    if (!row || !option) return
    if (!loanAccountNumber.trim()) {
      CreateAlert('Loan Account Number is required', 'Warning', setAlert)
      return
    }
    if (!nextEmiDate) {
      CreateAlert('Next EMI Date is required', 'Warning', setAlert)
      return
    }
    setStatusSaving(true)
    try {
      await axios.post(getApiBaseUrl() + '/financeregister/updatestatusbysales', {
        FinanceRegisterId: row.FinanceRegisterId,
        SalesId: row.SalesId,
        StatusId: option.value,
        LoanAccountNumber: loanAccountNumber,
        NextEmiDate: nextEmiDate,
        UserId: getStorageValues('userId')
      })
      CreateAlert('Status updated to Completed', 'Success', setAlert)
      closeStatusModal()
      props.fetchFinanceRegisters()
    } catch (error) {
      console.log(error)
      CreateAlert(error?.response?.data?.message || 'Unable to update status', 'Error', setAlert)
    } finally {
      setStatusSaving(false)
    }
  }

  function validation(financeRegisterDetails) {
    let isValid = true
    if (financeRegisterDetails) {
      if (!financeRegisterDetails.SalesId) {
        CreateAlert('Please select sales!!', 'Warning', setAlert)
        isValid = false
        return isValid
      }
      if (!financeRegisterDetails.FinancePartnerId) {
        CreateAlert('Please select finance partner!!', 'Warning', setAlert)
        isValid = false
        return isValid
      }
      const emiValue = Number(financeRegisterDetails.EMIAmount)
      if (!financeRegisterDetails.EMIAmount || Number.isNaN(emiValue) || emiValue <= 0) {
        CreateAlert('Please enter EMI amount!!', 'Warning', setAlert)
        isValid = false
      }
    } else {
      CreateAlert('Some problem fetching details entered by the user!!', 'Error', setAlert)
      return (isValid = false)
    }
    return isValid
  }

  const columns = [
    {
      name: <div className="titlename"><span>Sales #</span></div>,
      selector: row => row.SalesNumber,
      cell: (row) => (
        <span title={row.SalesNumber}>{row.SalesNumber}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Customer Name</span></div>,
      selector: row => row.CustomerName,
      cell: (row) => (
        <span title={row.CustomerName}>{row.CustomerName}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Loan Application No</span></div>,
      selector: row => row.LoanApplicationNo,
      cell: (row) => (
        <span title={row.LoanApplicationNo}>{row.LoanApplicationNo}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: (
        <div className="titlename">
          <span>Status</span>
        </div>
      ),
      selector: row => row.Status,
      cell: (row) => {
        const isCompleted = (row?.Status || '').toLowerCase() === 'completed' || (row?.Status || '').toLowerCase() === 'complete'
        const isEditing = editableCell.rowId === row.FinanceRegisterId && editableCell.column === 'Status'
        return isEditing ? (
          <StatusGridDropdown
            key={`status-${row.FinanceRegisterId}`}
            autoFocus={true}
            showLabel={false}
            selectedValue={row.StatusId}
            onChangeDropdown={(e) => {
              updateStatus(e, row)
              setEditableCell({ rowId: null, column: null })
            }}
            onBlur={() => setEditableCell({ rowId: null, column: null })}
            openMenuOnFocus={true}
            openMenuOnClick={true}
          />
        ) : (
          <div
            className="editable-cell-with-icon"
            onClick={() => {
              if (!isCompleted) {
                setEditableCell({ rowId: row.FinanceRegisterId, column: 'Status' })
              }
            }}
            style={{ cursor: 'pointer', height: '100%', width: '100%' }}
          >
            <div className="cell-content">{row.Status}</div>
            {!isCompleted && (
              <span className="edit-icon">
                <Icons.Edit size={12} color="#1261a0" />
              </span>
            )}
          </div>
        )
      },
      sortable: true,
      sortIcon: <SortArrow />
    }
  ]

  if (props.UserPermissions.ViewModule === 1 || props.UserPermissions.EditModule === 1 || props.UserPermissions.DeleteModule === 1) {
    columns.push({
      name: <div className="titlename">Actions</div>,
      cell: (row) => (
        <div className="edit-delete-action">
          {
            props.UserPermissions.ViewModule === 1
              ? (
                <Link
                  className="me-2 p-2"
                  to=""
                  onClick={() => {
                    openActionType(row, 'View')
                  }}
                >
                  <Icons.Eye data-feather="eye" className="action-eye" />
                </Link>
              )
              : null
          }
          {
            props.UserPermissions.EditModule === 1 && !['completed', 'complete', 'cancelled', 'canceled', 'cancel'].includes((row?.Status || '').toLowerCase())
              ? (
                <Link
                  className="me-2 p-2"
                  to=""
                  onClick={() => {
                    openActionType(row, 'Edit')
                  }}
                >
                  <Icons.Edit data-feather="edit" className="feather-edit" />
                </Link>
              )
              : null
          }
          
          {
            props.UserPermissions.DeleteModule === 1 && !['completed', 'complete', 'cancelled', 'canceled', 'cancel'].includes((row?.Status || '').toLowerCase())
              ? (
                <Link
                  className="confirm-text p-2"
                  to=""
                  onClick={() => {
                    openActionType(row, 'Delete')
                  }}
                >
                  <Icons.Trash2 data-feather="trash-2" className="feather-trash-2" />
                </Link>
              )
              : null
          }
          {
            props.UserPermissions.ViewModule === 1 && !['completed', 'complete', 'cancelled', 'canceled', 'cancel'].includes((row?.Status || '').toLowerCase())
              ? (
                <Link
                  className="me-2 p-2 m-2"
                  to=""
                  onClick={() => {
                    openActionType(row, 'Email')
                  }}
                  title="Send Email"
                >
                  <Icons.Mail data-feather="mail" size="14" className="feather-mail" />
                </Link>
              )
              : null
          }
        </div>
      ),
      center: 'true',
      width: '150px'
    })
  }

  const handleRowExpandToggled = (expanded, row) => {
    setExpandedRowId((prev) => (prev === row.FinanceRegisterId ? null : row.FinanceRegisterId))
  }

  const isRowExpanded = (row) => row.FinanceRegisterId === expandedRowId

  return (
    <>
      <SKAlerts alert={alert} />
      <div className="card table-list-card">
        <div className="card-body">
          <div className="table-top">
            <div className="search-set">
              <div className="search-input">
                <button type="button" className="btn btn-searchset">
                  <Icons.Search className="feather-search" />
                </button>
                <input
                  id="search"
                  type="text"
                  className="form-control form-control-sm custom-search-input"
                  placeholder="Search"
                  aria-label="Search Input"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                />
              </div>
            </div>
          </div>
          <DataTable
            className="table-responsive product-list"
            columns={columns}
            data={rows}
            pagination
            defaultSortField="SalesNumber"
            sortIcon={<SortArrow />}
            persistTableHead={true}
            expandableRows
            onRowExpandToggled={handleRowExpandToggled}
            expandableRowExpanded={isRowExpanded}
            expandableRowsComponent={FinanceRegisterFollowup}
            expandableRowsComponentProps={{ ref: followupRef }}
          />
        </div>
      </div>
      <FinanceRegisterModal
        show={modalIsOpen}
        UserAction={actionType}
        onClose={closeModal}
        selectedRow={financeRegisterModel}
        onSubmit={onSubmit}
        moduleName={moduleName}
      />
      <Modal show={statusModalOpen} onHide={closeStatusModal} backdrop="static" centered>
        <Modal.Header closeButton>
          <Modal.Title>Complete Finance Register</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Loan Account Number<span className="text-danger"> *</span></label>
            <input
              type="text"
              className="form-control"
              value={loanAccountNumber}
              onChange={(e) => setLoanAccountNumber(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Next EMI Date<span className="text-danger"> *</span></label>
            <input
              type="date"
              className="form-control"
              value={nextEmiDate}
              onChange={(e) => setNextEmiDate(e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-cancel" type="button" onClick={closeStatusModal} disabled={statusSaving}>Cancel</button>
          <button className="btn btn-submit" type="button" onClick={submitCompleteStatus} disabled={statusSaving}>
            {statusSaving ? 'Completing…' : 'Complete'}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default FinanceRegisterGrid
